import React, { useState } from 'react'
import moment from 'moment'
import { Button, Grid, Stack, Typography } from '@mui/material'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
import BigModal from '../../../../../components/Modals/BigModal'
import HeadInjury from './HeadInjury'
import AssessmentText from '../AssessmentText'
import CustomSelect from '../CustomSelect'
import NormalAbnormal from '../NormalAbnormal'

const Musculoskeletal = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Stack gap={2} padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Musculoskeletal</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            size="small"
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
          />
        </Grid>
        <CustomSelect
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
          label="Body Area"
          options={[
            'Head',
            'Neck',
            'Back',
            'Left Arm',
            'Right Arm',
            'Left Leg',
            'Right Leg',
            'Left Hand',
            'Right Hand',
            'Left Shoulder',
            'Right Shoulder',
            'Other',
          ]}
        />
        <NormalAbnormal
          fieldName="Movement"
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <CustomSelect
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
          label="Bruising"
          options={['Yes', 'No']}
        />
        <CustomSelect
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
          label="Swelling"
          options={['Yes', 'No']}
        />
        <CustomSelect
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
          label="Deformity"
          options={['Yes', 'No']}
        />
        <CustomSelect
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
          label="Crepitus"
          options={['Yes', 'No']}
        />
        <AssessmentText
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Grid item xs={12}>
          <Button
            onClick={() => submitModule('Musculoskeletal', moduleValues)}
            variant="contained"
            fullWidth
            color='success'
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Stack>
  )
}

// c-spine assessment
// chest assessment
//

export default Musculoskeletal
